export default function HowItWorks() {
  const steps = [
    {
      number: '01', title: 'Install & Import',
      description: 'Add JobOS Chrome Extension. Import your resume. Connect LinkedIn, Indeed, or upload a CSV of past applications.',
      image: 'https://public.readdy.ai/ai/img_res/8b1bf815ab469a9b1a3de65a4d2102ca.jpg',
      alt: 'JobOS Chrome extension installation and resume import screen'
    },
    {
      number: '02', title: 'Apply & Track',
      description: 'Browse jobs on any board. Click "Apply with JobOS" — we autofill the ATS form and add it to your tracker automatically.',
      image: 'https://readdy.ai/api/search-image?query=Job%20application%20form%20being%20automatically%20filled%20with%20candidate%20information%2C%20Workday%20ATS%20interface%20with%20highlighted%20autofill%20fields%2C%20JobOS%20Chrome%20extension%20popup%20overlay%2C%20form%20fields%20populating%20with%20data%20animation%2C%20dark%20professional%20UI%20design%20with%20indigo%20highlights&width=400&height=280&seq=jobos-step2-autofill&orientation=landscape',
      alt: 'JobOS autofill in action on Workday application form'
    },
    {
      number: '03', title: 'Tailor & Land',
      description: 'Use AI to tailor your resume for each role. Track responses. Schedule interviews. Get analytics. Land the offer.',
      image: 'https://readdy.ai/api/search-image?query=Split%20screen%20dashboard%20showing%20job%20application%20pipeline%20kanban%20board%20on%20left%20with%20status%20columns%20and%20AI%20resume%20editor%20panel%20on%20right%20with%20highlighted%20keyword%20matches%2C%20analytics%20charts%20at%20bottom%2C%20dark%20mode%20interface%20with%20indigo%20and%20emerald%20green%20accents%2C%20professional%20software%20UI&width=400&height=280&seq=jobos-step3-tailor&orientation=landscape',
      alt: 'JobOS dashboard showing application pipeline and AI resume tailoring panel'
    }
  ];

  return (
    <section id="how-it-works" className="py-[120px] bg-gray-50 dark:bg-[#0A0E1A]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-20">
          <div className="text-[#818CF8] text-sm font-mono uppercase tracking-wider mb-4">HOW IT WORKS</div>
          <h2 className="text-5xl font-extrabold text-gray-900 dark:text-white">From chaos to clarity in 3 steps</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {steps.map((step, index) => (
            <article key={index} className="flex flex-col">
              <div className="text-[#6366F1] text-[80px] font-extrabold leading-none mb-4">{step.number}</div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">{step.title}</h3>
              <p className="text-gray-500 dark:text-[#94A3B8] text-base leading-relaxed mb-8">{step.description}</p>
              <div className="rounded-lg border border-gray-200 dark:border-[#2D3148] overflow-hidden mt-auto">
                <img src={step.image} alt={step.alt} className="w-full h-[280px] object-cover object-top" loading="lazy" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
